/**
 * KAN-957: страница, которая сама тянется до низа экрана (доска и таблица CRM),
 * снимает нижний отступ кабинета (p-6 и запас под плавающую кнопку
 * видео-подсказки KAN-950): main получает pb-0, снизу остаётся отступ самой
 * страницы. С отступом блок "до низа экрана" (useFillViewportHeight) кончается
 * на высоту отступа выше низа. Место под кнопку такая страница оставляет сама.
 *
 * Значение контекста: снять отступ, вернуть функцию, которая его возвращает.
 * Вне кабинета (DashboardLayout) ничего не делает.
 */
import { createContext, useContext, useLayoutEffect } from 'react';

export type ReleaseBottomGutter = () => () => void;

const noop = () => undefined;

export const BottomGutterContext = createContext<ReleaseBottomGutter>(() => noop);

/** Пока active, нижнего отступа под кнопку подсказки у кабинета нет. */
export function useReleaseBottomGutter(active = true): void {
  const release = useContext(BottomGutterContext);
  // До отрисовки: высота до низа экрана считается уже без отступа.
  useLayoutEffect(() => (active ? release() : undefined), [active, release]);
}
